import React from 'react';
import PropTypes from 'prop-types';
import EmptySection from './EmptySection';
import { DeviceList } from '../../Devices/components';

const DeviceSection = ({
  devices,
  label,
  show,
  onToggle,
  onModifyDevice,
  onDetachDevice,
  onDetachDevices,
  onShowModal,
  onRemoveModal,
}) => (
  <div className={`collapse ${show ? 'in' : ''}`}>
    <div
      className="box-dispositivos-container col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-top-2"
      style={{ 'margin-top': '2%' }}
    >
      <button type="button" className="close" onClick={onToggle}>
        ×
      </button>
      <h4>
        <strong>{label.btnDeviceTitle}</strong>
      </h4>
      {label.btnDeviceDesc}
      <div
        className="box-dispositivos-asociados"
        style={{ 'margin-top': '2%' }}
      >
        {devices && devices.length === 0 && (
          <EmptySection label={{ historyEmpty: label.deviceEmpty }} />
        )}

        {devices && devices.length !== 0 && (
          <DeviceList
            devices={devices}
            modifyDevice={onModifyDevice}
            detachDevice={onDetachDevice}
            detachDevices={onDetachDevices}
            showModal={onShowModal}
            closeModal={onRemoveModal}
          />
        )}
      </div>
    </div>
  </div>
);

DeviceSection.propTypes = {
  label: PropTypes.object,
  show: PropTypes.bool,
  devices: PropTypes.array,
  onToggle: PropTypes.func,
  onModifyDevice: PropTypes.func,
  onDetachDevice: PropTypes.func,
  onDetachDevices: PropTypes.func,
  onShowModal: PropTypes.func,
  onRemoveModal: PropTypes.func,
};

export default DeviceSection;
